/* Bare minimum css to get things started */
.scrollsnap-control-dots {
  display: flex;
  flex-direction: row;
  justify-content: center;
  list-style: none;
  padding: 0;
}

.scrollsnap-control-dot {
  cursor: pointer;
}